import { Box, StyleProps } from "@acko-tech/building-blocks.ui.common";
import styled from "styled-components";

interface IStyleProps extends StyleProps {
  mStyles: any;
}
export const HeaderWrapper = styled(Box) <IStyleProps>`
  width: 100%;
  z-index:1;
  psoition: relative;
  @media (max-width: 768px) {
    ${({ mStyles }: any) => mStyles}
  }
`;
